import { render } from "./GroupBuySavePartial.vue?vue&type=template&id=c8b4d3d8"
import script from "./GroupBuySavePartial.vue?vue&type=script&lang=js"
export * from "./GroupBuySavePartial.vue?vue&type=script&lang=js"
script.render = render

export default script